import React from 'react';
import { Link } from 'react-router-dom';

import PublicLayout from './common/PublicLayout';

function Home() {
  return (
    <PublicLayout>
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white mb-6">
          Welcome to Hagley & District Light Car Club
        </h1>
        <p className="text-xl text-gray-400 mb-8">Join our community of motorsport enthusiasts</p>
        <div className="space-x-4">
          <Link
            to="/membership"
            className="bg-hdlcc-lightBlue text-white py-3 px-6 rounded-lg hover:bg-hdlcc-blue transition-colors inline-block"
          >
            Join the Club
          </Link>
          <Link
            to="/login"
            className="bg-white/10 text-white py-3 px-6 rounded-lg hover:bg-white/20 transition-colors inline-block"
          >
            Member Login
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}

export default Home;
